import React, { SVGAttributes } from 'react';

const Shield = (props: SVGAttributes<SVGElement>) => (
    <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
        <path
            d="m11.402 18.486 3.92 5.57a1.681 1.681 0 0 0 2.73.082l12.55-15.884"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M5.4 2A2.4 2.4 0 0 0 3 4.4v14.4c0 7.7 11.575 16.27 15.509 18.816a2.362 2.362 0 0 0 2.582 0C25.025 35.07 36.6 26.501 36.6 18.8V4.4A2.402 2.402 0 0 0 34.2 2H5.4Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Shield;
